<template>
  <div>
    <template v-if="$route.name == 'setInspector'">
      <ots-main-title></ots-main-title>
      <ots-refer
        class="mb20"
        :selectList="selectList"
        :request-form="requestForm"
        @search="search"
      />
      <ots-table-group-new
        :tableHeader="tableHeader"
        :tableData="tableData"
        :pagination="pagination"
        :batchOperBtn="batchOperBtn"
        @changeNum="changeSize"
        @changePage="changePage"
      ></ots-table-group-new>
      <ots-custom-dialog
        :dialog.sync="baseImportDialog"
        title="导入巡考员"
        width="480px"
      >
        <template v-slot:content>
          <div class="fileImport">
            <el-form ref="exportForm" :model="importForm">
              <el-form-item label="1.模板下载">
                <span
                  style="color: #006aff"
                  @click="$getStaticFile('巡考员导入模板.xlsx')"
                  class="cp"
                >
                  <i class="el-icon-download"></i>
                  下载巡考员导入模板
                </span>
              </el-form-item>
              <el-form-item label="2.导入巡考员" v-model="importForm.file">
                <ots-upload-file
                  :httpRequest="handleFormData"
                  fileType="xlsx"
                />
              </el-form-item>
            </el-form>
            <div class="impExplain">
              <span class="tipTitle"><i></i>提示：</span>
              <div>
                <div>
                  1：只能上传扩展名为<span class="col_red">.xlsx</span>的文件；
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <el-button round @click="baseImportDialog = false">取消</el-button>
          <el-button round type="primary" @click="rightImport">确定</el-button>
        </template>
      </ots-custom-dialog>

      <!-- 复制巡考员弹窗 -->
      <ots-custom-dialog
        :dialog.sync="copyDialog"
        title="请选择要复制的场次考点"
        width="480px"
      >
        <template v-slot:content>
          <ul class="copy_ul">
            <li class="copy_li" v-for="(item, index) in otherSessionList" :key="item.sessionId">
              <span>{{ item.sessionName + "："}}</span>
              <el-select v-model="copyForm[index]" placeholder="请选择">
                <el-option v-for="val in item.placeInfo" :key="val.placeId" :label="val.placeName" :value="val.placeId">
                </el-option>
              </el-select>
              <el-button type="primary" size="mini" plain round @click="isHasOther(item.sessionId, index, false)">复制</el-button>
            </li>
          </ul>
        </template>
        <template v-slot:footer>
          <el-button round @click="copyDialog = false">取消</el-button>
          <el-button round type="primary" @click="isHasOther(null, null, true)">一键复制</el-button>
        </template>
      </ots-custom-dialog>

    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>
<script>
import {
  getSelectPlanFn,
  getTourTeacherSessionList,
  getTourTeacherPlaceList,
  getTourTeacherListFn,
  tourTeacherImportExcel,
  checkOtherSessionAndCopyApi,
  checkTeacherIsSetApi,
  singleCopyApi,
  copyApi
} from "@/http/modules/examSet/examBatch";
export default {
  name: "setInspector",
  data() {
    return {
      baseImportDialog: false,
      importForm: {
        file: "",
      },
      batchOperBtn: [
        {
          title: "导入巡考员",
          click: this.stationUserImport,
        },
      ],
      selectList: [
        {
          title: "考试批次",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "场次",
          type: "select",
          requestKey: "sessionId",
          label: "name",
          value: "id",
          data: [{ id: "", name: "全部" }],
        },
        {
          title: "考点",
          type: "select",
          requestKey: "placeId",
          label: "placeName",
          value: "placeId",
        },
        {
          title: "关键词",
          type: "input",
          requestKey: "keyword",
          placeholder: "用户名/姓名",
        },
      ],
      tableHeader: [
        {
          title: "考试批次",
          prop: "planName",
        },
        {
          title: "场次",
          prop: "sessionName",
        },
        {
          title: "考点",
          prop: "placeName",
        },
        {
          title: "巡考员姓名",
          prop: "teacherName",
        },
        {
          title: "巡考员用户名",
          prop: "teacherId",
        },
        {
          title: "操作",
          type: "buttons",
          btnList: [
            {
              title: "设置巡考员",
              click: this.setinspect,
            },
            {
              title: "复制到其他场次",
              click: this.copyToOtherSession,
              formatter: (scoped) => {
                return !scoped.row.tid;
              },
            }
          ],
        }


      ],
      tableData: [],
      pagination: {
        total: 0,
       
      },
      requestForm: {
        planId: "",
        sessionId: "",
        placeId: "",
        page: 1,
        size: 10,
      },

      copyDialog: false,
      otherSessionList: [],
      copyForm: [],
      teacherId_copy: "",
    };
  },
  watch: {
    "requestForm.planId": function () {
      this.getTourTeacherSession();
      this.getClassList();
    },
    "requestForm.sessionId": function () {
      this.getTourTeacherPlace();
      this.getClassList();
    },
    "$route.name": function(val) {
      if (val === "setInspector") {
        this.getTourTeacherSession();
        this.getClassList();
      }
    }
  },
  mounted() {
    this.initData();
  },
  methods: {
    /**
     * @param { 复制到其它场次(弹窗开启) / 单场次复制 }
     */
    async copyToOtherSession(row) {
      this.copyForm = [];
      this.teacherId_copy = row.tid;
      let param = {
        planId: this.requestForm.planId,
        sessionId: row.sessionId,
        placeId: row.placeId,
        teacherId: row.tid,
      }
      const { data, code, msg } = await checkOtherSessionAndCopyApi(param);
      if (code === 1) {
        if (msg == "复制成功!") {
          this.$message.success(msg);
          this.getClassList();
          this.copyDialog = false;
        } else {
          this.copyDialog = true;
          this.otherSessionList = data;
          data.map(e=>{
            this.copyForm.push(e.placeInfo[0].placeId);
          })
        }
      }
    },

    /**
     * @param { 是否已设置巡考员 }
     */
    async isHasOther(sessionId, index, flag) {
      let param = {
        planId: this.requestForm.planId,
        sessionIdPlaceIds: sessionId + "_" + this.copyForm[index],
      }
      if (flag) {
        let sessionIdPlaceIds = [];
        for (let i = 0; i < this.copyForm.length; i++) {
          sessionIdPlaceIds.push(this.otherSessionList[i].sessionId + "_" + this.copyForm[i]);
        }
        param.sessionIdPlaceIds = sessionIdPlaceIds.join(",");
      }
      const { data, code } = await checkTeacherIsSetApi(param);
      if (code === 0) {
        this.$message.error("查询该场次下巡考员失败！");
        return;
      }
      if (data === 0) {
        if (flag) {
          this.copySessionMore(param);
        } else {
          this.copySessionOne(param);
        }
      } else {
        let test = flag ? "存在已设置巡考员的场次考点，如继续复制则会更替换为新的巡考员": "该场次下已设置巡考员，如继续复制则会更替换为新的巡考员";
        this.$confirm(test, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          if (flag) {
            this.copySessionMore(param);
          } else {
            this.copySessionOne(param);
          }
        }).catch(() => {
          this.$message.info("已取消复制");
        });
      }
    },

    /**
     * @param { 单场次 -- 场次复制 }
     */
    async copySessionOne(param) {
      param.sessionId = param.sessionIdPlaceIds.split("_")[0];
      param.placeId = param.sessionIdPlaceIds.split("_")[1];
      param.teacherId = this.teacherId_copy;
      const { code } = await singleCopyApi(param)
      if (code == 1) {
        this.$message.success("复制成功！");
        this.getClassList();
        this.copyDialog = false;
      }
    },

    /**
     * @param { 多场次 -- 场次复制 }
     */
    async copySessionMore(param) {
      param.teacherId = this.teacherId_copy;
      const { code } = await copyApi(param);
      if (code === 0) {
        this.$message.error("一键复制失败！");
      } else {
        this.$message.success("一键复制成功！");
        this.getClassList();
        this.copyDialog = false;  
      }
    },  


    search() {
      this.requestForm.page = 1;
      this.getClassList();
    },
    initData() {
      getSelectPlanFn({ needAudit: 6 }).then(({ data }) => {
        if (data) {
          this.$set(this.selectList[0], "data", data);
          this.requestForm.planId = data[0].id;
          this.getTourTeacherSession();
        }
      });
    },
    getTourTeacherSession() {
      //考场
      let params = {
        planId: this.requestForm.planId,
      };
      getTourTeacherSessionList(params).then((data) => {
        this.requestForm.sessionId = "";
        let sessionList = [{ id: "", name: "全部" }, ...data.data];
        this.$set(this.selectList[1], "data", sessionList);
      });
      this.getTourTeacherPlace();
    },
    getTourTeacherPlace() {
      //考点
      let paramsplace = {
        planId: this.requestForm.planId,
        sessionId: this.requestForm.sessionId,
      };
      getTourTeacherPlaceList(paramsplace).then((data) => {
        this.requestForm.placeId = "";
        let sessionList = [{ placeId: "", placeName: "全部" }, ...data.data];
        this.$set(this.selectList[2], "data", sessionList);
      });
    },

    getClassList() {
      //查询
      let params = {...this.requestForm};
      getTourTeacherListFn(params).then((res) => {
        this.tableData = res.data.records;
        this.pagination.total = res.data.total;
      });
    },
    changeSize(num) {
      this.requestForm.size = num;
      this.getClassList();
    },
    changePage(p) {
      this.requestForm.page = p;
      this.getClassList(true);
    },
    setinspect(row) {
      this.$router.push({
        name: "setInspectorAssistant",
        query: {
          planId: row.planId,
          sessionId: row.sessionId,
          placeId: row.placeId,
          placeName: row.placeName,
          planName: row.planName,
          sessionName: row.sessionName,
        },
      });
    },
    stationUserImport() {
      this.baseImportDialog = true;
    },
    handleFormData(val) {
      this.importForm.file = val.file;
    },
    async rightImport() {
      // 1. 是否空文件
      if (!this.importForm.file) {
        this.$message.error("请选择文件");
        return;
      }
      // 2. 创建 formData 对象实例
      const fd = new FormData();
      for (let item in this.importForm) {
        fd.append(item, this.importForm[item]);
      }
      // 3. 调用上传文件接口
      const { code, data } = await tourTeacherImportExcel(fd);
      if (code == 1) {
        // 4. 设置 成功 / 失败 条数
        const failNum = data.errorCount ? parseInt(data.errorCount) : 0;
        const totalNum = parseInt(data.allCount);
        const successNum = totalNum - failNum;
        let message = `导入完成，成功导入${successNum}，失败人员数${failNum}`;
        // 5. 关闭上传文件弹窗
        this.baseImportDialog = false;
        // 6. 文件导入结果提示
        this.$confirm(message, "导入结果", {
          confirmButtonText: failNum > 0 ? "查看错误记录" : "确定",
          cancelButtonText: "取消",
          type: failNum > 0 ? "warning" : "success",
        })
          .then(async () => {
            if (failNum > 0) {
              window.location.href = data.address;
            }
          })
          .catch(() => {});
        // 7. 重置 table 表数据
        this.getResult();
      }
    },
  },
};
</script>
<style lang="less" scoped>
.copy_ul {
  width: 100%; 
  height: auto; 
}
.copy_li {
  width: 100%; 
  height: 36px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
</style>